import { useState } from "react";
import { useApi } from "providers/ProvideApi";
import { wrapError } from "../../utils";
import { useAlert } from "advancement-solutions-components/dist/providers";

export const useRequestOtp = () => {
  const { api } = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { send } = useAlert();

  const requestOtp = async (values) => {
    try {
      setIsLoading(true);
      setError(null);
      await api.post(`api/users/${values.id}/otp`, { email: values.email });
      send({
        message:
          "Your OTP request has been sent. An email should arrive shortly.",
        severity: "info",
      });
    } catch (e) {
      send({
        message: "There was a problem with your request.",
        severity: "error",
      });
      setError(wrapError(e));
    } finally {
      setIsLoading(false);
    }
  };
  return [requestOtp, isLoading, error];
};

export default useRequestOtp;
